import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

import { DotIcon, InfoIcon } from '../../theme/AthenaIcons';


const styles = theme => ({
  softGreyFont: {
    color: '#b1b1b1',
  },
  infoIcon: {
    height: 19,
  },
});


@withStyles(styles)
class WhiteTooltip extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    dotColor: PropTypes.string,
  };

  static defaultProps = {
    title: null,
    dotColor: null,
  };

  render() {
    const { title, children, dotColor, classes } = this.props;
    const CustomTooltip = withStyles(theme => ({
      tooltip: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black,
        boxShadow: theme.shadows[1],
        fontSize: 15,
        padding: 25,
        minWidth: 350,
      },
    }))(Tooltip);
    const structure = (
      <Grid item container>
        <Grid container alignItems="center">
          {dotColor === null
            ? null
            : <DotIcon fill={dotColor} />
          }
          {title === null
            ? null
            : <span className={classes.softGreyFont}>{title}</span>
          }
        </Grid>
        <Grid>
          {children}
        </Grid>
      </Grid>
    );
    return (
      <CustomTooltip title={structure}>
        <div className={classes.infoIcon}><InfoIcon /></div>
      </CustomTooltip>
    );
  }
}


export default WhiteTooltip;
